import { updateUserStatus } from './authActions';

export const onPushData = (data) => (dispatch) => {
  dispatch(updateUserStatus());
};
